module.exports = __webpack_public_path__ + "static/media/loader-01.35098067.svg";